module.exports = __webpack_public_path__ + "static/media/DistractionTechniques.fdc259e2.mp3";